import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const patientsApi = {
    getPatientByTrialInstitution: (trialId: number, institutionId: number): Observable<Dtos.GetPatientsByTrialInstitutionResponse> => {
        //Create the request.
        let request: Dtos.GetPatientsByTrialInstitution = new Dtos.GetPatientsByTrialInstitution();

        request.trialId = trialId;
        request.institutionId = institutionId;

        //Send request.
        const response: Promise<Dtos.GetPatientsByTrialInstitutionResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    }
}